import ready from '../utils/ready';

const moduleLinks = () => {
  document.querySelectorAll('[data-module-type]')?.forEach((module) =>
    module.querySelectorAll('.content').forEach((content) => {
      content.querySelectorAll('a')?.forEach((anchor) => {
        const internal = anchor.href.startsWith(origin) || anchor.href.startsWith('/');
        if (!internal) {
          anchor.target = '_blank';
          anchor.rel = 'noopener noreferrer';
        }
      });
    })
  );
};

ready(moduleLinks);
